export default __webpack_public_path__ + "static/media/guest_06_patricia_anunciada.f7e8fdb4.png";